// Flyin Brand Colors
export const BRAND_PRIMARY = '#2A5298'
export const BRAND_PRIMARY_DARK = '#1E3A8A'
export const BRAND_PRIMARY_LIGHT = '#90b4e8'
export const BRAND_SECONDARY = '#FFD700'
export const BRAND_SECONDARY_DARK = '#E6C200'
export const BRAND_SECONDARY_LIGHT = '#FFE066'
export const BRAND_PRIMARY_100 = '#eef6ff'
//borders
export const BORDER_MAIN = '#e5e7eb'
export const BORDER_SECONDARY = '#d1d5db'

// neutral scale
export const WHITE = '#fff'
export const BLACK = '#000'
export const NEUTRAL_100 = '#f9fafb'

//text
export const TEXT_PRIMARY = '#000'
export const TEXT_SECONDARY = '#4b5563'
export const TEXT_SUBHEADING = '#6b7280'
export const TEXT_DISABLED = '#9ca3af'
export const TEXT_SUBTITLE = '#374151'

//link
export const LINK_MAIN = '#2463EB'

//error
export const ERROR_MAIN = '#dc2626'
export const ERROR_LIGHT = '#fef2f2' // Very light red background

//success
export const SUCCESS_MAIN = '#16a34a'
export const SUCCESS_LIGHT = '#f0fdf4' // Very light green background

// warning
export const WARNING_MAIN = '#f2bf42'

//sign-in promo banner
export const SIGN_IN_PROMO_BANNER_BG = 'linear-gradient(135deg, #E2EDFE 0%, #CFE1FA 100%)'
export const SIGN_IN_PROMO_BANNER_PILL_BG = '#E7F0FD'
export const SIGN_IN_PROMO_BANNER_PILL_BORDER = '#D5E4F7'
export const SIGN_IN_PROMO_BANNER_CTA_BG = '#1B4D9C'
export const SIGN_IN_PROMO_BANNER_CTA_HOVER_BG = '#143C7E'

//seat layout
export const SEAT_LAYOUT_COLORS_0 = '#d9f1e8'
export const SEAT_LAYOUT_COLORS_1 = '#A4CDFF'
export const SEAT_LAYOUT_COLORS_2 = '#9db6e6'
export const SEAT_LAYOUT_COLORS_3 = '#5F8EEE'
export const SEAT_LAYOUT_COLORS_4 = '#985289'
export const SEAT_LAYOUT_COLORS_5 = '#4D1A37'
export const UNAVAILABLE_SEAT_COLOR = '#BDBDBD'

// destination page
export const DESTINATION_HERO_BG = '#1a2332'
export const DESTINATION_HERO_OVERLAY = 'rgba(26, 35, 50, 0.82)'
export const DESTINATION_HERO_TEXT_MUTED = 'rgba(255, 255, 255, 0.6)'
export const DESTINATION_HERO_TEXT_SECONDARY = 'rgba(255, 255, 255, 0.75)'
export const DESTINATION_HERO_TEXT_PRIMARY = 'rgba(255, 255, 255, 0.85)'
export const DESTINATION_HERO_CHIP_BG = 'rgba(255, 255, 255, 0.12)'
export const DESTINATION_HERO_CHIP_BORDER = 'rgba(255, 255, 255, 0.2)'
export const DESTINATION_HERO_SEARCH_SHADOW = '0 8px 32px rgba(0, 0, 0, 0.3)'
export const DESTINATION_HOTEL_CARD_OVERLAY = 'rgba(0, 0, 0, 0.45)'

// chart / data-visualisation
export const CHART_TEMP_HIGH = '#F97316'
export const CHART_TEMP_LOW = '#0EA5E9'
export const CHART_RAINFALL = '#93C5FD'
export const CHART_BAR_FARE = '#91D2DC'
export const CHART_AXIS_LABEL = '#64748B'
export const CHART_GRID_LINE = '#E2E8F0'
